import React from "react";
import PettyCashApproval from "./PettyCashApproval";

const PettyCashDMApproval = () => <PettyCashApproval role="dm" />;

export default PettyCashDMApproval;